var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-info';
                    var viewUrl = 'sprite.svg#view-icon-info';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };